import React from 'react';
import styled from 'styled-components';
import type { IBuyerNotifications } from '@bb/contacts';

import { Checkbox, Text } from 'components';
import type { CheckboxProps } from 'components/Checkbox';

interface BuyerNotificationProps {
  value: IBuyerNotifications;
  onChange: (updates: IBuyerNotifications) => void;
}

const BUYER_NOTIFICATION_KEY_LABEL_LIST: {
  key: keyof IBuyerNotifications;
  label: string;
}[] = [
  { key: 'Booked', label: 'Requested' },
  { key: 'Confirmed', label: 'Confirmed' },
  { key: 'Cancelled', label: 'Cancelled' },
  { key: 'Deny', label: 'Deny' },
  { key: 'Time Change', label: 'Time Change' },
];

const BuyerNotification: React.FC<BuyerNotificationProps> = ({
  value: buyerNotifications,
  onChange,
}) => {
  const createCheckValueChangeHandler =
    (key: keyof IBuyerNotifications): CheckboxProps['onChange'] =>
    event => {
      const updatedNotificationOptions = {
        ...buyerNotifications,
        [key]: event.target.checked,
      };

      onChange(updatedNotificationOptions);
    };

  return (
    <StyledBuyerNotificationSettingsContainer>
      {BUYER_NOTIFICATION_KEY_LABEL_LIST.map(({ key, label }) => (
        <div key={key}>
          <Checkbox
            checked={buyerNotifications[key]}
            onChange={createCheckValueChangeHandler(key)}
          >
            <Text>{label}</Text>
          </Checkbox>
        </div>
      ))}
    </StyledBuyerNotificationSettingsContainer>
  );
};

export default BuyerNotification;

const StyledBuyerNotificationSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
`;
